import { baseApi } from "./baseApi";

const CROSS_DOCKING_BASE_URL = "/cross-docking"

export const crossDockingApi = baseApi.injectEndpoints({
    tagTypes: ["CrossDocking"],

    endpoints: (builder) => ({
        addCrossDocking: builder.mutation({
            query: (payLoad) => ({
                url: CROSS_DOCKING_BASE_URL,
                method: "POST",
                body: payLoad
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "CrossDocking", id: _id },
                { type: "CrossDocking", id: "LIST" },
            ],
        }),

        listCrossDocking: builder.query({
            query: (params) => ({
                url: CROSS_DOCKING_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "CrossDocking", _id })),
                        { type: "CrossDocking", id: "LIST" },
                    ]
                    : [{ type: "CrossDocking", id: "LIST" }],
        }),

        getDDLCrossDockingList: builder.query({
            query: (params) => ({ url: `${CROSS_DOCKING_BASE_URL}/ddl`, params }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "CrossDocking", _id })),
                        { type: "CrossDocking", id: "DDL" },
                    ]
                    : [{ type: "CrossDocking", id: "DDL" }],
        }),

        getCrossDockingDetail: builder.query({
            query: (crossId) => `${CROSS_DOCKING_BASE_URL}/${crossId}`,
            providesTags: (_result, _error, { _id }) => [
                { type: "CrossDocking", _id },
                { type: "CrossDocking", id: "LIST" },
            ],
        }),

        updateCrossDocking: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${CROSS_DOCKING_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "CrossDocking", id },
                { type: "CrossDocking", id: "LIST" },
            ],
        }),
    })
})
export const {
    useAddCrossDockingMutation,
    useListCrossDockingQuery,
    useLazyListCrossDockingQuery,
    useLazyGetDDLCrossDockingListQuery,
    useGetCrossDockingQuery,
    useGetCrossDockingDetailQuery,
    useUpdateCrossDockingMutation,
} = crossDockingApi;